import { ChangeDetectorRef, inject, Pipe, PipeTransform } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { UnleashFlags } from './unleash.const';
import { UnleashService } from './unleash.service';

@Pipe({
  name: 'unleashEnabled',
  pure: false,
})
export class UnleashPipe implements PipeTransform {
  readonly #unleash = inject(UnleashService);

  readonly #changeRef = inject(ChangeDetectorRef);

  constructor() {
    this.#unleash
      .watch()
      .pipe(takeUntilDestroyed())
      .subscribe(() => this.#changeRef.markForCheck());
  }

  transform(feature: UnleashFlags) {
    return this.#unleash.isEnabled(feature);
  }
}
